import React from "react";

interface FacebookIconProps {
  className?: string;
  fill?: string;
  height?: number;
  width?: number;
}

const FacebookIcon = ({
  className,
  fill,
  height = 30,
  width = 30
}: FacebookIconProps) => (
  <svg width={width} height={height} viewBox="0 0 30 30" className={className}>
    <path
      fill={fill}
      d="M27.792 0H1.208C.541 0 0 .541 0 1.208v26.584C0 28.459.541 29 1.208 29H15.49V17.77h-3.78v-4.377h3.78v-3.228c0-3.745 2.288-5.785 5.629-5.785 1.6 0 2.976.12 3.377.172v3.915l-2.317.001c-1.818 0-2.17.864-2.17 2.13v2.795h4.334l-.564 4.377h-3.77V29h7.783c.667 0 1.208-.541 1.208-1.208V1.208C29 .541 28.459 0 27.792 0z"
    />
  </svg>
);

export default FacebookIcon;
